import React from 'react';
import styles from './components.module.scss';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

interface AdminTasksProps {
  adminTasks: {
    answerPhone?: boolean;
    takePayments?: boolean;
    outboundPatientCalls?: boolean;
    hygieneCoordinating?: boolean;
    checkinPatients?: boolean;
    seatPatients?: boolean;
    stericentre?: boolean;
    floater?: boolean;
    attire?: number;
  };
  attire?: string | number;
}

const taskLabels = {
  answerPhone: 'Answer Phone',
  takePayments: 'Take Payments',
  outboundPatientCalls: 'Outbound Patient Calls',
  hygieneCoordinating: 'Hygiene Coordinating',
  checkinPatients: 'Check-in Patients',
  seatPatients: 'Seat Patients',
  stericentre: 'Sterilization Centre',
  floater: 'Floater (Multiple Duties)'
};

const attireLabels = {
  '0': 'Business Attire',
  '1': 'Scrubs',
  '2': 'Either Business or Scrubs',
  business: 'Business Attire',
  scrubs: 'Scrubs',
  either: 'Either Business or Scrubs'
};

export const AdminTasksDisplay: React.FC<AdminTasksProps> = ({ adminTasks, attire }) => {
  const activeTasks = Object.entries(adminTasks)
    .filter(([key, value]) => value && key !== 'attire')
    .map(([key, _]) => taskLabels[key as keyof typeof taskLabels])
    .filter(Boolean);

  const hasAttire = attire !== undefined && attire !== null && attire !== '';

  // T2-6509: with missing/incomplete legacy ShiftTasks, render nothing rather than
  // an empty "Required Tasks:" heading / blank list or a bare heading.
  if (activeTasks.length === 0 && !hasAttire) {
    return null;
  }

  return (
    <div className={styles.adminTasksContainer}>
      <h3>📋 Reception/Admin Position</h3>

      {activeTasks.length > 0 && (
        <div className={styles.tasksSection}>
          <h4>Required Tasks:</h4>
          <ul className={styles.tasksList}>
            {activeTasks.map((task, index) => (
              <li key={index}>
                <CheckCircleIcon style={{ color: 'var(--success-main)', fontSize: '1.2rem' }} />
                <span>{task}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {hasAttire && (
        <div className={styles.attireSection}>
          <h4>Attire Requirements:</h4>
          <p>{attireLabels[attire as keyof typeof attireLabels] || attire}</p>
        </div>
      )}
    </div>
  );
}; 